import React from "react";

export default function ISPLicenseRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ISP License Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists telecom service providers with ISP License Registration in compliance with DoT regulations.
          </p>
          <p className="text-gray-700">
            Complete licensing including ISP Category-A/B/C applications, spectrum allocation, network rollout plan approval, SACFA clearance, interconnection agreements, and USOF compliance.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: ISP telecom license compliance) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184417/pexels-photo-3184417.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="ISP license registration and telecom compliance services"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless DoT ISP License approvals.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Company incorporation documents</li>
                <li>Net worth certificate</li>
                <li>Technical and network details</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Telecom regulatory expertise with proven success in DoT ISP licensing across Category A/B/C authorizations.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Telecom Regulatory Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of Unified License, ISP Authorization rules including Category-A pan-India, Category-B telecom circle, Category-C district-level requirements, net worth thresholds, and TRAI interconnection compliance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Compliance Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise DoT submissions, SACFA wireless clearances, spectrum auction coordination, network diagram validation, performance bank guarantee processing, annual license fee calculations, and compliance reporting.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service licensing from LOI issuance through Wireless Operating License (WOL), Letter of Intent (LoI) execution, interconnection agreements with backbone providers, USOF levy compliance, and ongoing regulatory advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
